import { Component, OnInit, Input } from '@angular/core';
import { TicketTransactionModel, TicketTransactionType, TicketService, Ticket, TicketDetails } from '@fgb/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment/moment';

@Component({
  selector: 'fgbcl-ticket-transfer-log',
  templateUrl: './ticket-transfer-log.component.html',
  styleUrls: ['./ticket-transfer-log.component.scss'],
})
export class TicketTransferLogComponent implements OnInit {
  @Input() ticket: Ticket;
  ticketLog$: Observable<TicketTransactionModel[]>;
  @Input() ticketColumn1: TicketDetails = TicketDetails.Area;
  @Input() ticketColumn2: TicketDetails = TicketDetails.Stand;

  ticketDetails = TicketDetails;

  constructor(private ticketSerivce: TicketService, private translate: TranslateService) {}

  ngOnInit() {
    this.ticketLog$ = this.ticketSerivce
      .fetchTransferHistory(this.ticket.MemberId, this.ticket.ACN, this.ticket.GameNumber)
      .pipe(tap((logItems) => logItems.map((item) => (item.Date = moment.utc(item.Date).local().toDate()))));
  }

  ticketTransferStatus(type: TicketTransactionType) {
    let status = TicketTransactionType[type];
    switch (type) {
      case TicketTransactionType.CallBack: {
        status = this.translate.instant('fgbcl.ticket.transfer.status.called.back');
        break;
      }
      case TicketTransactionType.Transferred: {
        status = this.translate.instant('fgbcl.ticket.transfer.status.transferred');
        break;
      }
    }

    return status;
  }
}
